import React from 'react';
import { Outlet } from 'react-router-dom';

import CssBaseline from '@mui/material/CssBaseline';
import DrawerMenu from '../DrawerMenu/DrawerMenu';

import styles from './AppLayout.module.css';

const AppLayout: React.FC = () => (
  <div className={styles['app-layout-root']}>
    <CssBaseline />
    <DrawerMenu />
    <main className={styles['app-layout-main']}>
      <Outlet />
    </main>
  </div>
);

export default AppLayout;
